import Views from "@/views";
import Layout from "@/components/Layouts/Index.vue";

/* Views */
const { tuitionDiscounts, tuitionPriceLists, tuitionPriceLines, payments, enrollmentCharge, EnrollmentAppliedDiscounts, FiscalPeriods, AccountReceivable, CollectionAccount } = Views;

const collectionRouter = {
  path: "/collection",
  component: Layout,
  redirect: "dashboard",
  name: "",
  history: false,
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: "tuition-discounts",
      name: "TuitionDiscounts",
      component: tuitionDiscounts,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "tuition-price-lists",
      name: "TuitionPriceLists",
      component: tuitionPriceLists,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "tuition-price-lines",
      name: "TuitionPriceLines",
      component: tuitionPriceLines,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "payments",
      name: "Payments",
      component: payments,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "enrollmentcharge",
      name: "enrollmentcharge",
      component: enrollmentCharge,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "appliediscounts",
      name: "appliediscounts",
      component: EnrollmentAppliedDiscounts,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "fiscalperiods",
      name: "fiscalperiods",
      component: FiscalPeriods,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "account-receivable",
      name: "accountReceivable",
      component: AccountReceivable,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "collection-account/:Id?",
      name: "CollectionAccount",
      component: CollectionAccount,
      hidden: true,
      meta: {
        requiresAuth: true,
      },
    },
  ],
};

export default collectionRouter;
